<div class="w-100 h-100 main-team container-for-scroll">
  <div class="w-100 tab-header">
    <div class="team-list-header">
      @if (userCreatedTeam) {
        <ng-container [ngTemplateOutlet]="teamNameEditTemplate"></ng-container>
      }
      @for (team of visibleTeams; track team) {
        <ng-container
          [ngTemplateOutlet]="teamsTemplate"
          [ngTemplateOutletContext]="{team:team}"
        ></ng-container>
      }
      @if (teams.length >= minPageCountForNavigation) {
        <button class="btn-trs" (click)="nextPage()"
                [ngStyle]="{'display': currentPage >= maxPage ? 'none' : ''}">
          <mat-icon class="nav-to-many">chevron_right</mat-icon>
        </button>
        <button class="btn-trs" (click)="prevPage()"
                [ngStyle]="{'display': currentPage < maxPage ? 'none' : ''}">
          <mat-icon class="nav-to-many">chevron_left</mat-icon>
        </button>
      }
    </div>
    <ng-container [ngTemplateOutlet]="addNewMemberTemplate"></ng-container>
  </div>

  <div class="w-100 tab-header non-visible-tab-header">
    <div class="team-list-header">
      @if (userCreatedTeam) {
        <ng-container [ngTemplateOutlet]="teamNameEditTemplate"></ng-container>
      }
      @for (team of getAllTeams; track team) {
        <ng-container
          [ngTemplateOutlet]="teamsTemplate"
          [ngTemplateOutletContext]="{team:team}"
        ></ng-container>
      }
      <ng-container [ngTemplateOutlet]="addNewMemberTemplate"></ng-container>
    </div>
  </div>
  <div class="all-cards w-100">
    @if (isListView) {
      <div class="cards-history-grid-container">
        @for (wrappedCard of wrappedCards; track wrappedCard) {
          <app-single-card-grid
            [team]="userCreatedTeam"
            [activeSubscription]="activeSubscription"
            [singleCard]="wrappedCard"
            [isFavoriteMap]="isFavoriteMap"
            [isDeleteButtonFromHistoryActive]="false"
            [isDeleteButtonFromTeamActive]="isDeleteButtonActive(wrappedCard.userCardResponse)"
            [isStarActive]="wrappedCard?.userCardResponse?.userId != currentUserId"
            [showEditSection]="isEditSectionVisibleForGird(wrappedCard.userCardResponse)"
            [isCardActive]="wrappedCard.userCardResponse.active"
            [isTeamCards]="true"
            [reservedIdentificationId]="reservedIdentificationId"
            (activeReservedQrCard)= "onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
            (cardAdded)="addNewCard($event)"
            class="resp-flex"
          ></app-single-card-grid>
        }
      </div>
    } @else {
      <div class="list-view">
        @if (cards.length > 0) {
          <div class="member-info-container member-info-text disable-resp">{{ 'my_team.members' | translate }}</div>
          <div class="line-container"></div>
        }
        @for (wrappedCard of wrappedCards; track wrappedCard) {
          <app-single-card-list
            [team]="userCreatedTeam"
            [activeSubscription]="activeSubscription"
            [singleCard]="wrappedCard"
            [isFavoriteMap]="isFavoriteMap"
            [isDeleteButtonFromHistoryActive]="false"
            [isDeleteButtonFromTeamActive]="isDeleteButtonActive(wrappedCard.userCardResponse)"
            [isStarActive]="wrappedCard?.userCardResponse?.userId != currentUserId"
            [showEditSection]="isEditSectionVisibleForGird(wrappedCard.userCardResponse)"
            [currentUserEmail]="currentUserEmail"
            [currentUserId]="currentUserId"
            [reservedIdentificationId]="reservedIdentificationId"
            (activeReservedQrCard)= "onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
            [isAdminCard]="isAdminCard(wrappedCard.userCardResponse.userId)"
            [isCardActive]="wrappedCard.userCardResponse.active"
            [isTeam]="true"
            (cardAdded)="addNewCard($event)"
          ></app-single-card-list>
          <label class="line-for"></label>
        }
        @if (cards.length > 0) {
          <div class="member-info-container-footer disable-resp"></div>
        }
      </div>
    }
  </div>
  <div class="nav-more">
    @if (totalElementCount > cards.length) {
      <div class="d-flex justify-content-center mt-4 flex-direction-row gap-10px">
        @if (!isLoading) {
          <button class="load-history-button">{{ 'my_team.load_more' | translate }}</button>

          <div class="search-loader">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if (userCreatedTeam !== null && activeTeamIndex === userCreatedTeam.id) {
    <div class="common-footer">
      <button class="outlined-button mobile-button tall-button gap-10px" (click)="openEditDialogForMemberAdd()">
        <mat-icon>add</mat-icon>
        {{ 'my_team.add_new_member' | translate }}
      </button>
    </div>
  }
</div>

<ng-template #teamNameEditTemplate>
  @if (!isEditTeamNameActive) {
    <div [ngClass]="{'selected-my-team': activeTeamIndex === userCreatedTeam.id}"
         (click)="deleteActiveTeamIndex() ; setActiveTeam(userCreatedTeam.id) "
         class="my-team">
      <span class="my-team-name mtn-rep">{{ getTranslatedTeamName(userCreatedTeam.name) }}</span>
      <div class="icon-container">
        <mat-icon class="my-team-icon" (click)="isEditTeamNameActive = true">edit</mat-icon>
        <span class="tooltip-text">Edit team name</span>
      </div>
    </div>
    } @else {
      <label class="my-team active-edit">
        <form [formGroup]="editTeamNameForm">
          <input formControlName="newName" type="text" class="my-team-edit-input"
                 [value]="userCreatedTeam.name"
                 (keyup.enter)="editTeamName()">
        </form>
        <mat-icon class="my-team-icon" (click)="editTeamName()">check</mat-icon>
      </label>
  }
</ng-template>

<ng-template #teamsTemplate let-team='team'>
  <div [ngClass]="{'selected-my-team': activeTeamIndex === team.id}"
       (click)="setActiveTeam(team.id); updateTeam(team.id)"
       class="other-team">
    <span class="my-team-name">{{ getTranslatedTeamName(team.name) }}</span>
  </div>
</ng-template>

<ng-template #addNewMemberTemplate>
  @if (userCreatedTeam !== null && activeTeamIndex === userCreatedTeam.id) {
    <button class="add-member-header" (click)="openEditDialogForMemberAdd()">
      <span class="add-member-header-text">{{ 'my_team.add_new_member' | translate }}</span>
    </button>
  }
</ng-template>
